document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.js-typewriter');
  if (!root) return;

  const rootSpeed = parseInt(root.dataset.speed || '40', 10);
  const rootDelay = parseInt(root.dataset.delay || '0', 10);

  // 句読点での追加ポーズ（ms）
  const PAUSE_MS = 220;
  const PAUSE_RE = /[.,!?;:、。・…—-]/;

  function typeOne(block, done) {
    const ghostText = block.querySelector('.ghost .tw-text');
    const visText   = block.querySelector('.visible .tw-text');
    if (!ghostText || !visText) { done && done(); return; }

    // ブロックごとの上書き
    const speed = parseInt(block.dataset.speed || rootSpeed, 10);
    const delay = parseInt(block.dataset.delay || rootDelay, 10);
    const unit  = (block.dataset.unit || '').toLowerCase(); // 'word' or 'char'

    const source = ghostText.textContent;

    // トークン化：英語などは単語単位、日本語は文字単位
    const tokens = (unit === 'word')
      ? source.split(/(\s+)/) // 空白も保持
      : Array.from(source);   // サロゲートペア対応

    visText.textContent = '';
    block.querySelector('.visible').classList.add('is-typing');

    let i = 0;
    const tick = () => {
      if (i < tokens.length) {
        visText.textContent += tokens[i++];
        // 句読点なら一拍置く
        const lastChar = visText.textContent.slice(-1);
        const extra = PAUSE_RE.test(lastChar) ? PAUSE_MS : 0;
        setTimeout(tick, speed + extra);
      } else {
        const vis = block.querySelector('.visible');
        vis.classList.remove('is-typing');
        vis.classList.add('is-typed');
        done && done();
      }
    };

    setTimeout(tick, delay);
  }

  function start() {
    const blocks = Array.from(root.querySelectorAll('.tw-block'));
    let idx = 0;
    const run = () => { if (idx < blocks.length) typeOne(blocks[idx++], run); };
    run();
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { io.disconnect(); start(); } });
  }, { root: null, rootMargin: '0px 0px -15% 0px', threshold: 0 });

  io.observe(root);

  // 既にライン内なら即開始（保険）
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const bottomLine = vh * 0.85;
  const rect = root.getBoundingClientRect();
  if (rect.top < bottomLine && rect.bottom > 0) {
    io.disconnect();
    start();
  }
});